import React from "react";
import LayoutStyles from "../../../toolkit/baseStyles";

export default class Layout extends React.Component<any, any> {
  render() {
    return (
      <LayoutStyles>
        <div>{this.props.children}</div>
      </LayoutStyles>
    );
  }
}
